import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";
import { ApolloProvider, ApolloClient, InMemoryCache } from "@apollo/client";
import { registerMediaType } from "traverson";
import JsonHalAdapter from "traverson-hal";

import { initiateSentry } from "commons/src/Sentry";

import { store } from "./store";
import { App } from "./components/App";

import "commons/src/css/font-faces.css";

document.cookie = "shss=true;Path=/;max-age=900;";
registerMediaType(JsonHalAdapter.mediaType, JsonHalAdapter);
initiateSentry("https://9433fa9ca02a4bb0bcd93527d2185a43@sentry.io/1223998");

const apolloClient = new ApolloClient({
    uri: `${window.location.origin}/nucleus-nuclear/nui/nbs/graphql`,
    connectToDevTools: process.env.NODE_ENV === "development",
    cache: new InMemoryCache()
});

const root = createRoot(document.getElementById("root"));

root.render(
    <ApolloProvider client={apolloClient}>
        <Provider store={store}>
            <HashRouter>
                <App />
            </HashRouter>
        </Provider>
    </ApolloProvider>
);
